// Presets curados de formato de fecha para campos de data-grid del editor
// low-code. `value` es el patrón dayjs que se persiste en `field.dateFormat`
// ('' = texto plano, sin formateo). Las etiquetas muestran el resultado para
// la fecha de referencia 2026-06-20 14:30.

export const DATE_FORMAT_PRESETS = [
  { label: 'Texto plano (sin formato)', value: '' },
  { label: '2026-06-20', value: 'YYYY-MM-DD' },
  { label: '20-06-2026', value: 'DD-MM-YYYY' },
  { label: '20/06/2026', value: 'DD/MM/YYYY' },
  { label: '20/06/2026 14:30', value: 'DD/MM/YYYY HH:mm' },
  { label: '20 de junio del 2026', value: 'DD [de] MMMM [del] YYYY' },
  { label: '20 de junio del 2026, 14:30', value: 'DD [de] MMMM [del] YYYY, HH:mm' },
  { label: '14:30', value: 'HH:mm' },
  { label: '2026-06-20 14:30', value: 'YYYY-MM-DD HH:mm' },
];
